<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="46" viewBox="0 0 32 46" fill="none">
        <g filter="url(#filter0_d_1734_430)">
            <path d="M14 28H4L18 0V16H28L14 44V28Z" fill="white" />
        </g>
        <defs>
            <filter id="filter0_d_1734_430" x="0" y="0" width="32" height="52" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.639216 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1734_430" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1734_430" result="shape" />
            </filter>
        </defs>
    </svg>
</template>